<template>
  <div class="sign">
    <navBar />
    <div class="sign-content">
      <div class="sign-tip">
        <img class="suc-icon" src="https://restaskimg.civaonline.cn/imagesH5/apply-suc.png" alt="">
        <p class="tip">
          申请成功
        </p>
      </div>
      <div class="sign-text">
        <span>登录账号：13866887722</span>
        <span>初始密码：手机号后六位 </span>
      </div>
      <p class="sign-con">
        体验期2个月，首次登录后开始计算!
      </p>
    </div>
    <div class="pc-link">
      <span>教师中心PC端地址</span>
      <div class="copy">
        <input id="input" v-model="scanInfo" readOnly="readOnly" type="text">
        <span class="copy-btn unselect" data-clipboard-action="copy" data-clipboard-target="#input" @click="copy">复制</span>
      </div>
    </div>
    <div class="qr-code">
      <div class="list">
        <img src="https://restaskimg.civaonline.cn/static/images/help-download/teacherqr.png" alt="">
        <span>教师中心APP</span>
      </div>
      <div class="list">
        <img src="https://restaskimg.civaonline.cn/static/images/help-download/civastuqr.png" alt="">
        <span>学生端App</span>
      </div>
    </div>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
  data() {
    return {
      scanInfo: 'http://civaweb.civaonline.cn/middle/civaLogin.do',
    }
  },
  methods: {
    copy() {
      const clipboard = new Clipboard('.copy-btn') // 注意要使用let或者const，不能使用var，否则会出现复制次数叠加的问题，即复制不止一次。
      clipboard.on('success', e => {
        this.$toast('复制成功');
        clipboard.destroy() // 使用destroy可以清除缓存
      })
      clipboard.on('error', e => {
        this.$toast('复制失败，请手动选择复制');
        clipboard.destroy()
      })
    },
  },
}
</script>

<style scoped lang="less">
  .sign{
    width: 100%;
    height: 100vh;
    background: #F6F7FB;
    &-content{
      width: 100%;
      background: #fff;
    }
    &-tip{
      text-align: center;
      padding-top: 80px;
      .suc-icon{
        width: 120px;
        text-align: center;
      }
      .tip{
        font-size: 32px;
        color: #FF7500;
        line-height: 32px;
        margin-top: 20px;
      }
    }
    &-text{
      color: #333333;
      line-height: 46px;
      padding: 30px 42px;
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
    }
    &-con{
      color: #999999;
      line-height: 39px;
      text-align: center;
      padding-bottom: 76px;
    }
    .pc-link{
      height: 164px;
      color: #333333;
      line-height: 46px;
      padding: 21px 42px 0;
      box-sizing: border-box;
      margin-top: 20px;
      background: #fff;
      .copy{
        display: flex;
      }
      input{
        font-size: 24px;
        color: #151515;
        flex: 1;
      }
      .copy-btn{
        color: #1577DE;
      }
      .unselect {
        -webkit-touch-callout:none;
        -webkit-user-select:none;
        -khtml-user-select:none;
        -moz-user-select:none;
        -ms-user-select:none;
        user-select:none;
      }
    }
    .qr-code{
      width: 100%;
      height: 560px;
      box-sizing: border-box;
      padding: 167px 124px;
      display: flex;
      justify-content: space-between;
      .list{
        width: 180px;
        text-align: center;
        color: #333333;
        line-height: 46px;
        img{
          width: 180px;
        }
      }
    }
  }
</style>
